import { Static, Type } from '@sinclair/typebox'

export const KizeoAdminSession = Type.Object({
    adminId: Type.Number(),
    userId: Type.Number(),
    firstName: Type.String(),
    lastName: Type.String(),
    email: Type.String(),
    division: Type.Union([Type.Number(), Type.Null()]),
})

export type KizeoAdminSession = Static<typeof KizeoAdminSession>
